<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Judges</h1>
    </div>
    <div slot="content">
      <div>
        <h2 class="h3 mb-3">Pending Expressions of Interest</h2>
        <router-link
          tag="button"
          :to="{ name: 'Pending Expression Of Interest' }"
          class="btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5">
          Manage Expressions
        </router-link>
      </div>
      <div>
        <h2 class="h3 mb-3">Approved Expressions of Interest</h2>
        <router-link
          tag="button"
          :to="{ name: 'Approved Expression Of Interest' }"
          class="btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5">
          View Lists
        </router-link>
      </div>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'

export default {
  name: "JudgeSecretaryDashboard",
  components: {
    'listing-layout': listingLayout
  },
  data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Judges/Secretary/JudgeSecretaryDashboard.vue